<template>
  <div :class="pageCss">

    <div
      :style="'background-image: url('+heroImage+')'"
      :class="{ 'page__background': true, 'page__background--preload' : heroImageBlur, 'overlay-full': true }"
    ></div>

    
    <div class="page__intro">
    
      <div class="wrapper">

        <div>

          <div class="wrapper__inner--intro">


            <span class="chip" v-html="content.chip"></span>
            <h1 v-html="content.title"></h1>
            <h4 v-html="content.subtitle"></h4>
            
            <button class="default" @click.prevent="navigateThroughPages(1);">
              {{ content.ctaCopy }}
              <span>
                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 23.1 19.3" style="enable-background:new 0 0 23.1 19.3;" xml:space="preserve">
                  <polygon points="21.5,8.2 13.8,0 12.2,1.6 18.8,8.6 0,8.6 0,10.8 18.9,10.8 12.5,17.7 14.1,19.3 23.1,9.7 "/>
                </svg>
              </span>
            </button>


          </div>

        </div>

      </div>
      <section-footer css-class="intro"></section-footer>

    </div>

    <img v-images-loaded:on.done="heroImageLoaded" :src="content.heroImage.loaded" class="hero-preload">

    <!--<div class="overlay__default"><span></span><span></span></div>-->

  </div>
</template>

<script>

  import imagesLoaded from 'vue-images-loaded'
  
  // mixins
  //import ShareContent from '@/mixins/shareContent';
  import NavigatePages from '@/mixins/navigatePages';
  import HeroImageLoaded from '@/mixins/heroImageLoaded';


  // section content blocks
  import SectionFooter from '@/components/Blocks/SectionFooter.vue';

  export default {
    name: 'FrontCover',
    directives: {
      imagesLoaded
    },
    props: {
      content: {
        type: Object,
        required: true
      }
    },
    metaInfo() {
      return {
        title: this.content.meta.title,
        meta: [
          { name: 'description', content: this.content.meta.description },
          { property: 'og:type', content: this.content.meta.og.type },
          { property: 'og:title', content: this.content.meta.og.title },
          { property: 'og:description', content: this.content.meta.og.description },
          { property: 'og:image', content: this.content.meta.og.image },
          { name: 'twitter:card', content: this.content.meta.twitter.card },
          { name: 'twitter:title', content: this.content.meta.twitter.title },
          { name: 'twitter:description', content: this.content.meta.twitter.description },
          { name: 'twitter:site', content: this.content.meta.twitter.site },
          { name: 'twitter:creator', content: this.content.meta.twitter.creator },
          { name: 'twitter:image', content: this.content.meta.twitter.image }
        ]
      }
    },
    data() {
      return {
        heroImage: this.content.heroImage.preload,
        heroImageBlur: true
      }
    },
    mixins: [ NavigatePages, HeroImageLoaded ],
    computed: {
      pageCss() {
        return `page ${this.content.cssClass}`;
      }
    },
    components: {
      SectionFooter
    }
  };
</script>